export default "__VITE_ASSET__BRi6QHlj__"